import React from "react";

export default function ReportsIcon(props?: any) {

  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
  .filter(key => svgStyles[key] !== null && svgStyles[key] !== undefined)
  .reduce((acc: any, key) => {
    acc[key] = svgStyles[key];
    return acc;
  }, {});

  return (        
    <svg 
      viewBox="0 0 118 118" 
      style={{...filteredStyles, fill : "none"}}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.1818 64.3636V112.636C32.1818 114.059 31.6167 115.423 30.6108 116.429C29.605 117.435 28.2407 118 26.8182 118H5.36364C3.94111 118 2.57685 117.435 1.57097 116.429C0.565096 115.423 0 114.059 0 
        112.636V64.3636C0 62.9411 0.565096 61.5769 1.57097 60.571C2.57685 59.5651 3.94111 59 5.36364 59H26.8182C28.2407 59 29.605 59.5651 30.6108 60.571C31.6167 61.5769 32.1818 62.9411 32.1818 64.3636ZM69.7273 
        0H48.2727C46.8502 0 45.4859 0.565096 44.4801 1.57097C43.4742 2.57685 42.9091 3.94111 42.9091 5.36364V112.636C42.9091 114.059 43.4742 115.423 44.4801 116.429C45.4859 117.435 46.8502 118 48.2727 
        118H69.7273C71.1498 118 72.5141 117.435 73.5199 116.429C74.5258 115.423 75.0909 114.059 75.0909 112.636V5.36364C75.0909 3.94111 74.5258 2.57685 73.5199 1.57097C72.5141 0.565096 71.1498 0 69.7273 
        0ZM112.636 26.8182H91.1818C89.7593 26.8182 88.395 27.3833 87.3892 28.3892C86.3833 29.395 85.8182 30.7593 85.8182 32.1818V112.636C85.8182 114.059 86.3833 115.423 87.3892 116.429C88.395 117.435 89.7593 
        118 91.1818 118H112.636C114.059 118 115.423 117.435 116.429 116.429C117.435 115.423 118 114.059 118 112.636V32.1818C118 30.7593 117.435 29.395 116.429 28.3892C115.423 27.3833 114.059 26.8182 112.636 26.8182Z" fill={filteredStyles.fill || "#3B4559"} />
    </svg>
  )
}